import { maybe } from "@saleor/misc";
import moment from "moment";

import { IFilterElement } from "../../../../components/Filter";
import {
  createFilterTabUtils,
  createFilterUtils,
  getGteLteVariables,
  getMinMaxQueryParam,
  getSingleEnumValueQueryParam
} from "../../../../utils/filters";
import {
  paymentEnum,
  PayoutsDetailPageFilterKeys,
  PayoutsDetailsPageFilterOpts
} from "../../components/PayoutsDetailsPage/filters";
import {
  PayoutDetailsUrlFilterEnum,
  PayoutDetailsUrlFilters,
  PayoutDetailsUrlQueryParams
} from "../../urls";
export const PAYOUT_DETAILS_FILTER_KEY = "PayoutDetailsFilters";

export function getFilterOpts(
  params: PayoutDetailsUrlFilters
): PayoutsDetailsPageFilterOpts {
  return {
    completedAt: {
      active: maybe(
        () =>
          [params.orderCompleteDateFrom, params.orderCompleteDateTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.orderCompleteDateTo, ""),
        min: maybe(() => params.orderCompleteDateFrom, "")
      }
    },
    orderDate: {
      active: maybe(
        () =>
          [params.orderDateFrom, params.orderDateTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.orderDateTo, ""),
        min: maybe(() => params.orderDateFrom, "")
      }
    },
    paymentMethodType: {
      active: !!params.paymentMethodType,
      value: maybe(() => params.paymentMethodType, "")
    },
    settlementDate: {
      active: maybe(
        () =>
          [params.settlementDateFrom, params.settlementDateTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.settlementDateTo, ""),
        min: maybe(() => params.settlementDateFrom, "")
      }
    }
  };
}

export function getFilterVariables(params: PayoutDetailsUrlFilters) {
  return {
    completedAt: getGteLteVariables({
      gte: params.orderCompleteDateFrom
        ? moment(`${params.orderCompleteDateFrom} 00:00:00`).format(
            "YYYY-MM-DD HH:mm:ssZZ"
          )
        : null,
      lte: params.orderCompleteDateTo
        ? moment(`${params.orderCompleteDateTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : null
    }),
    orderDate: getGteLteVariables({
      gte: params.orderDateFrom
        ? moment(`${params.orderDateFrom} 00:00:00`).format(
            "YYYY-MM-DD HH:mm:ssZZ"
          )
        : null,

      lte: params.orderDateTo
        ? moment(`${params.orderDateTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : null
    }),
    paymentMethodType: params.paymentMethodType,
    search: params.query,
    settlementDate: getGteLteVariables({
      gte: params.settlementDateFrom
        ? moment(`${params.settlementDateFrom} 00:00:00`).format(
            "YYYY-MM-DD HH:mm:ssZZ"
          )
        : null,

      lte: params.settlementDateTo
        ? moment(`${params.settlementDateTo} 00:00:00`)
            .add(1, "days")
            .format("YYYY-MM-DD HH:mm:ssZZ")
        : null
    })
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<PayoutsDetailPageFilterKeys>,
  params: PayoutDetailsUrlFilters
): PayoutDetailsUrlFilters {
  const { active, group, name, value } = filter;

  if (!!group) {
    const rest = params && params[group] ? params[group] : undefined;

    return {
      [group]: active
        ? {
            ...(rest === undefined ? {} : rest),
            [name]: value
          }
        : rest
    };
  }

  switch (name) {
    case PayoutsDetailPageFilterKeys.orderDate:
      return getMinMaxQueryParam(
        filter,
        PayoutDetailsUrlFilterEnum.orderDateFrom,
        PayoutDetailsUrlFilterEnum.orderDateTo
      );
    case PayoutsDetailPageFilterKeys.completedAt:
      return getMinMaxQueryParam(
        filter,
        PayoutDetailsUrlFilterEnum.orderCompleteDateFrom,
        PayoutDetailsUrlFilterEnum.orderCompleteDateTo
      );
    case PayoutsDetailPageFilterKeys.settlementDate:
      return getMinMaxQueryParam(
        filter,
        PayoutDetailsUrlFilterEnum.settlementDateFrom,
        PayoutDetailsUrlFilterEnum.settlementDateTo
      );
    case PayoutsDetailPageFilterKeys.paymentMethodType:
      return getSingleEnumValueQueryParam(
        filter,
        PayoutDetailsUrlFilterEnum.paymentMethodType,
        paymentEnum
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<PayoutDetailsUrlFilters>(PAYOUT_DETAILS_FILTER_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  PayoutDetailsUrlQueryParams,
  PayoutDetailsUrlFilters
>({
  ...PayoutDetailsUrlFilterEnum
});
